import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userName: "",
  userType: "",
  isUserLoggedIn: false,
  user: {},
  alerts:{},
  alertsRegister:false,
  globalCMSData:{},
  profileInfo:{},
  alertsCount:"",
  firebaseConfig: null,
  isAlertsLoading: false,
  isUserNotified: false,
  alertsData:{},
  selectedAlert:{},
  passwordExpired: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userData: (state, action) => {
      (state.userName = action.payload.userFirstName),
        (state.userType = action.payload.userType),
        (state.isUserLoggedIn = action.payload.isUserLoggedIn);
      state.user = action.payload.user;
    },
    logOut: (state, action) => {
      // localStorage.removeItem('recentSearch');
      (state.userName = ""),
        (state.userType = ""),
        (state.user = {}),
        (state.isUserLoggedIn = action.payload.isUserLoggedIn);
        state.alertsRegister = false;
        state.passwordExpired = false;
    },
    setGlobalCMSData: (state, action) => {
      (state.globalCMSData = action.payload);
    },
    setFirebaseConfig: (state, action) => {
      (state.firebaseConfig = action.payload);
    },
    setAlerts: (state, action) => {
      // Filter out incomplete alert objects (empty objects from API)
      const alerts = action.payload?.alerts;
      if (alerts && alerts.length > 0) {
        const validAlerts = alerts.filter(alert => alert && alert.message);
        if (validAlerts.length > 0) {
          (state.alertsData = { ...action.payload, alerts: validAlerts });
          (state.alerts = validAlerts);
        }
        // If no valid alerts in the response, keep existing data
      } else {
        (state.alertsData = action.payload);
        (state.alerts = alerts || []);
      }
    },
    setAlertsRegister: (state, action) => {
      (state.alertsRegister = action.payload);
    },
    setProfileInfo:(state, action) => {
      (state.profileInfo = action.payload);
    },
    setAlertsCount: (state, action) => {
      (state.alertsCount = action.payload);
    },
    setSelectedAlert: (state, action) => {
      (state.selectedAlert = action.payload);
    },
    setIsAlertsLoading:(state, action) => {
      (state.isAlertsLoading = action.payload);
    },
    setIsUserNotified: (state, action) => {
      (state.isUserNotified = action.payload);
    },
    setPasswordExpired: (state, action) => {
      console.log('action.payload ', action.payload);
      (state.passwordExpired = action.payload);
    }
  },
});

export const { userData, logOut, setAlerts , setAlertsRegister,setGlobalCMSData, setProfileInfo, setAlertsCount, setFirebaseConfig, setIsAlertsLoading, setIsUserNotified, setSelectedAlert, setPasswordExpired} = userSlice.actions;
export default userSlice.reducer;
